import ManagedLookup from '../components/ManagedLookup';
import fields from './fields';
import useLookupPage from '../hooks/useLookupPage';
import columns from './columns';

const Zones = ({ definition }) => {
    const page = useLookupPage('zones', columns);
    return <ManagedLookup definition={definition} columns={columns} fields={fields} page={page} allowAddAliases />;
};

export default Zones;
